import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'

import {
  EditProfileConfirmResult,
  TFitterProfileResponse,
  TFitterProfileUpdateRequest,
} from '../types'

export const fitterApi = createApi({
  reducerPath: 'fitter',
  baseQuery: getBaseQueryAuth,
  tagTypes: ['profile'],
  endpoints: builder => ({
    getFitter: builder.query<TFitterProfileResponse, void>({
      query: () => ({
        url: '/v1/fitter/profile',
        method: 'GET',
      }),
      providesTags: ['profile'],
    }),
    updateFitter: builder.mutation<
      EditProfileConfirmResult,
      TFitterProfileUpdateRequest
    >({
      query: body => ({
        url: '/v1/fitter/update-main-data',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['profile'],
    }),
  }),
})

export const { useGetFitterQuery, useUpdateFitterMutation } = fitterApi
